import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import { TextField } from '@material-ui/core';

class TextAnswer extends Component {

    handleChange = (question_id, question_type_id) => (event) => {
        const { selectAnswer } = this.props;

        selectAnswer(question_id, question_type_id, event.target.value);
    }

    getAnswerContent = (question_id, question_type_id, answer) => {
        const { studentAnswers } = this.props;
        let answerText = '';
        
        if(typeof studentAnswers[question_id] !== 'undefined') {
            answerText = studentAnswers[question_id];
        }

        switch(question_type_id)
        {
            case(2): // Short Text
            {
                return (
                    <TextField
                        value={answerText}
                        onChange={this.handleChange(question_id, question_type_id)}
                        margin="normal"
                        variant="outlined"
                    />
                );
                break;
            }
            case(3): // Long Text
            {
                return (
                    <TextField
                        value={answerText}
                        onChange={this.handleChange(question_id, question_type_id)}
                        margin="normal"
                        multiline
                        rows="4"
                        style={{ width: '100%' }}
                        variant="outlined"
                    />
                );
                break;
            }
            default: {}
        }
    }

    render() {
        const { answer, question } = this.props;

        if (typeof answer === 'undefined') {
            return <div>Loading...</div>
        }

        return (
            <React.Fragment>
                {this.getAnswerContent(question.header.question_id, question.header.question_type_id, answer)}
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectAnswer: Actions.selectAnswer,
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
        studentAnswers: quizApp.quizViewer.studentAnswers
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TextAnswer)));




// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/questionType/TextAnswer.js